(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-education-homepage"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Find the section-header element - it should be a parent element or use closest
      // Shopify wraps sections with the class from schema, so we look for the closest parent with that class
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      
      // If still not found, try finding it by looking for the section wrapper
      if (!this.header) {
        this.header = this.closest('section[class*="section-header"]') || this.parentElement?.closest('.section-header');
      }
      
      // Safety check - if header not found, exit early
      if (!this.header) {
        console.warn('StickyHeader: .section-header element not found');
        return;
      }
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Account dropdown toggle
  document.addEventListener('DOMContentLoaded', function() {
    const accountToggle = document.querySelector('.header__account-toggle');
    const accountMenu = document.querySelector('.header__account-menu');
    const accountDropdown = document.querySelector('.header__account-dropdown');
    
    if (accountToggle && accountMenu && accountDropdown) {
      accountToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isOpen = accountMenu.classList.contains('active');
        
        if (isOpen) {
          accountMenu.classList.remove('active');
          accountToggle.setAttribute('aria-expanded', 'false');
        } else {
          accountMenu.classList.add('active');
          accountToggle.setAttribute('aria-expanded', 'true');
        }
      });
      
      // Close dropdown when clicking outside
      document.addEventListener('click', function(e) {
        if (!accountMenu.contains(e.target)) {
          accountMenu.classList.remove('active');
          accountToggle.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Close dropdown on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && accountMenu.classList.contains('active')) {
          accountMenu.classList.remove('active');
          accountToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Account drawer toggle (mobile)
    const accountToggleMobile = document.querySelector('.header__account-toggle-mobile');
    const accountDrawer = document.querySelector('account-drawer');
    const accountDrawerDetails = document.getElementById('Details-account-drawer-container');
    const accountDrawerClose = accountDrawer?.querySelector('.account-drawer__close-button');

    if (accountToggleMobile && accountDrawerDetails) {
      accountToggleMobile.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        accountDrawerDetails.setAttribute('open', '');
        accountToggleMobile.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden-tablet');
      });

      if (accountDrawerClose) {
        accountDrawerClose.addEventListener('click', function() {
          accountDrawerDetails.removeAttribute('open');
          accountToggleMobile.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
        });
      }

      // Close drawer when clicking on overlay
      accountDrawerDetails.addEventListener('click', function(e) {
        if (e.target === accountDrawerDetails || e.target.closest('.account-drawer-container') === accountDrawerDetails && !e.target.closest('.account-drawer')) {
          accountDrawerDetails.removeAttribute('open');
          accountToggleMobile.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });

      // Close drawer on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && accountDrawerDetails.hasAttribute('open')) {
          accountDrawerDetails.removeAttribute('open');
          accountToggleMobile.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });
    }

    // Add class to header when secondary mega menu is shown
    const header = document.querySelector('.header');
    const secondaryMegaMenus = document.querySelectorAll('.secondary-mega-menu');
    const allMenuContents = document.querySelectorAll('.secondary-mega-menu__content');
    
    if (header && secondaryMegaMenus.length > 0) {
      // Store all hide timeouts in a shared object
      const hideTimeouts = {};
      
      // Function to hide all menus except the specified one
      function hideAllMenusExcept(exceptMenuContent) {
        allMenuContents.forEach(function(content) {
          if (content !== exceptMenuContent) {
            content.classList.remove('is-visible');
            // Clear any pending timeout for this menu
          }
        });
      }
      
      // Function to check if any menu is currently visible
      function hasVisibleMenu() {
        return Array.from(allMenuContents).some(function(content) {
          return content.classList.contains('is-visible');
        });
      }
      
      secondaryMegaMenus.forEach(function(menu) {
        const menuTriggerIndex = menu.getAttribute('data-menu-trigger');
        const menuContent = document.querySelector('.secondary-mega-menu__content[data-menu-content="' + menuTriggerIndex + '"]');
        
        if (menuContent) {
          // Function to show menu
          function showMenu() {
            // Clear all timeouts first
            Object.keys(hideTimeouts).forEach(function(key) {
              clearTimeout(hideTimeouts[key]);
              delete hideTimeouts[key];
            });
            
            // Hide all other menus immediately
            hideAllMenusExcept(menuContent);
            
            // Show this menu
            menuContent.classList.add('is-visible');
            header.classList.add('secondary-mega-menu-open');
          }
          
          // Function to hide menu with delay
          function hideMenu() {
            // Clear any existing timeout for this menu
            if (hideTimeouts[menuTriggerIndex]) {
              clearTimeout(hideTimeouts[menuTriggerIndex]);
            }
            
            hideTimeouts[menuTriggerIndex] = setTimeout(function() {
              // Only hide if mouse is not over trigger or dropdown
              if (!menu.matches(':hover') && !menuContent.matches(':hover')) {
                menuContent.classList.remove('is-visible');
                
                // Only remove header class if no other menu is visible
                if (!hasVisibleMenu()) {
                  header.classList.remove('secondary-mega-menu-open');
                }
              }
              
              // Clean up timeout reference
              delete hideTimeouts[menuTriggerIndex];
            }, 100); // Small delay to allow mouse movement
          }
          
          // Mouse enter on trigger - show menu
          menu.addEventListener('mouseenter', showMenu);
          
          // Mouse leave on trigger - hide menu (with delay)
          menu.addEventListener('mouseleave', hideMenu);
          
          // Mouse enter on dropdown - keep it visible
          menuContent.addEventListener('mouseenter', showMenu);
          
          // Mouse leave on dropdown - hide it (with delay)
          menuContent.addEventListener('mouseleave', hideMenu);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-main-homepage"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Find the section-header element - it should be a parent element or use closest
      // Shopify wraps sections with the class from schema, so we look for the closest parent with that class
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      
      // If still not found, try finding it by looking for the section wrapper
      if (!this.header) {
        this.header = this.closest('section[class*="section-header"]') || this.parentElement?.closest('.section-header');
      }
      
      // Safety check - if header not found, exit early
      if (!this.header) {
        console.warn('StickyHeader: .section-header element not found');
        return;
      }
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Account dropdown toggle
  document.addEventListener('DOMContentLoaded', function() {
    const accountToggle = document.querySelector('.header__account-toggle');
    const accountMenu = document.querySelector('.header__account-menu');
    const accountDropdown = document.querySelector('.header__account-dropdown');
    
    if (accountToggle && accountMenu && accountDropdown) {
      accountToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isOpen = accountMenu.classList.contains('active');
        
        if (isOpen) {
          accountMenu.classList.remove('active');
          accountToggle.setAttribute('aria-expanded', 'false');
        } else {
          accountMenu.classList.add('active');
          accountToggle.setAttribute('aria-expanded', 'true');
        }
      });
      
      // Close dropdown when clicking outside
      document.addEventListener('click', function(e) {
        if (!accountMenu.contains(e.target)) {
          accountMenu.classList.remove('active');
          accountToggle.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Close dropdown on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && accountMenu.classList.contains('active')) {
          accountMenu.classList.remove('active');
          accountToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Account drawer toggle (mobile)
    const accountToggleMobile = document.querySelector('.header__account-toggle-mobile');
    const accountDrawer = document.querySelector('account-drawer');
    const accountDrawerDetails = document.getElementById('Details-account-drawer-container');
    const accountDrawerClose = accountDrawer?.querySelector('.account-drawer__close-button');

    if (accountToggleMobile && accountDrawerDetails) {
      accountToggleMobile.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        accountDrawerDetails.setAttribute('open', '');
        accountToggleMobile.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden-tablet');
      });

      if (accountDrawerClose) {
        accountDrawerClose.addEventListener('click', function() {
          accountDrawerDetails.removeAttribute('open');
          accountToggleMobile.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
        });
      }

      // Close drawer when clicking on overlay
      accountDrawerDetails.addEventListener('click', function(e) {
        if (e.target === accountDrawerDetails || e.target.closest('.account-drawer-container') === accountDrawerDetails && !e.target.closest('.account-drawer')) {
          accountDrawerDetails.removeAttribute('open');
          accountToggleMobile.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });

      // Close drawer on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && accountDrawerDetails.hasAttribute('open')) {
          accountDrawerDetails.removeAttribute('open');
          accountToggleMobile.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });
    }

    // Add class to header when secondary mega menu is shown
    const header = document.querySelector('.header');
    const secondaryMegaMenus = document.querySelectorAll('.secondary-mega-menu');
    const allMenuContents = document.querySelectorAll('.secondary-mega-menu__content');
    
    if (header && secondaryMegaMenus.length > 0) {
      // Store all hide timeouts in a shared object
      const hideTimeouts = {};
      
      // Function to hide all menus except the specified one
      function hideAllMenusExcept(exceptMenuContent) {
        allMenuContents.forEach(function(content) {
          if (content !== exceptMenuContent) {
            content.classList.remove('is-visible');
            // Clear any pending timeout for this menu
          }
        });
      }
      
      // Function to check if any menu is currently visible
      function hasVisibleMenu() {
        return Array.from(allMenuContents).some(function(content) {
          return content.classList.contains('is-visible');
        });
      }
      
      secondaryMegaMenus.forEach(function(menu) {
        const menuTriggerIndex = menu.getAttribute('data-menu-trigger');
        const menuContent = document.querySelector('.secondary-mega-menu__content[data-menu-content="' + menuTriggerIndex + '"]');
        
        if (menuContent) {
          // Function to show menu
          function showMenu() {
            // Clear all timeouts first
            Object.keys(hideTimeouts).forEach(function(key) {
              clearTimeout(hideTimeouts[key]);
              delete hideTimeouts[key];
            });
            
            // Hide all other menus immediately
            hideAllMenusExcept(menuContent);
            
            // Show this menu
            menuContent.classList.add('is-visible');
            header.classList.add('secondary-mega-menu-open');
          }
          
          // Function to hide menu with delay
          function hideMenu() {
            // Clear any existing timeout for this menu
            if (hideTimeouts[menuTriggerIndex]) {
              clearTimeout(hideTimeouts[menuTriggerIndex]);
            }
            
            hideTimeouts[menuTriggerIndex] = setTimeout(function() {
              // Only hide if mouse is not over trigger or dropdown
              if (!menu.matches(':hover') && !menuContent.matches(':hover')) {
                menuContent.classList.remove('is-visible');
                
                // Only remove header class if no other menu is visible
                if (!hasVisibleMenu()) {
                  header.classList.remove('secondary-mega-menu-open');
                }
              }
              
              // Clean up timeout reference
              delete hideTimeouts[menuTriggerIndex];
            }, 100); // Small delay to allow mouse movement
          }
          
          // Mouse enter on trigger - show menu
          menu.addEventListener('mouseenter', showMenu);
          
          // Mouse leave on trigger - hide menu (with delay)
          menu.addEventListener('mouseleave', hideMenu);
          
          // Mouse enter on dropdown - keep it visible
          menuContent.addEventListener('mouseenter', showMenu);
          
          // Mouse leave on dropdown - hide it (with delay)
          menuContent.addEventListener('mouseleave', hideMenu);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Account dropdown toggle
  document.addEventListener('DOMContentLoaded', function() {
    const accountToggle = document.querySelector('.header__account-toggle');
    const accountMenu = document.querySelector('.header__account-menu');
    const accountDropdown = document.querySelector('.header__account-dropdown');
    
    if (accountToggle && accountMenu && accountDropdown) {
      accountToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const isOpen = accountMenu.classList.contains('active');
        
        if (isOpen) {
          accountMenu.classList.remove('active');
          accountToggle.setAttribute('aria-expanded', 'false');
        } else {
          accountMenu.classList.add('active');
          accountToggle.setAttribute('aria-expanded', 'true');
        }
      });
      
      // Close dropdown when clicking outside
      document.addEventListener('click', function(e) {
        if (!accountMenu.contains(e.target)) {
          accountMenu.classList.remove('active');
          accountToggle.setAttribute('aria-expanded', 'false');
        }
      });
      
      // Close dropdown on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && accountMenu.classList.contains('active')) {
          accountMenu.classList.remove('active');
          accountToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Account drawer toggle (mobile)
    const accountToggleMobile = document.querySelector('.header__account-toggle-mobile');
    const accountDrawer = document.querySelector('account-drawer');
    const accountDrawerDetails = document.getElementById('Details-account-drawer-container');
    const accountDrawerClose = accountDrawer?.querySelector('.account-drawer__close-button');

    if (accountToggleMobile && accountDrawerDetails) {
      accountToggleMobile.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        accountDrawerDetails.setAttribute('open', '');
        accountToggleMobile.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden-tablet');
      });

      if (accountDrawerClose) {
        accountDrawerClose.addEventListener('click', function() {
          accountDrawerDetails.removeAttribute('open');
          accountToggleMobile.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
        });
      }

      // Close drawer when clicking on overlay
      accountDrawerDetails.addEventListener('click', function(e) {
        if (e.target === accountDrawerDetails || e.target.closest('.account-drawer-container') === accountDrawerDetails && !e.target.closest('.account-drawer')) {
          accountDrawerDetails.removeAttribute('open');
          accountToggleMobile.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });

      // Close drawer on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && accountDrawerDetails.hasAttribute('open')) {
          accountDrawerDetails.removeAttribute('open');
          accountToggleMobile.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('overflow-hidden-tablet');
        }
      });
    }

    // Add class to header when secondary mega menu is shown
    const header = document.querySelector('.header');
    const secondaryMegaMenus = document.querySelectorAll('.secondary-mega-menu');
    const allMenuContents = document.querySelectorAll('.secondary-mega-menu__content');
    
    if (header && secondaryMegaMenus.length > 0) {
      // Store all hide timeouts in a shared object
      const hideTimeouts = {};
      
      // Function to hide all menus except the specified one
      function hideAllMenusExcept(exceptMenuContent) {
        allMenuContents.forEach(function(content) {
          if (content !== exceptMenuContent) {
            content.classList.remove('is-visible');
            // Clear any pending timeout for this menu
          }
        });
      }
      
      // Function to check if any menu is currently visible
      function hasVisibleMenu() {
        return Array.from(allMenuContents).some(function(content) {
          return content.classList.contains('is-visible');
        });
      }
      
      secondaryMegaMenus.forEach(function(menu) {
        const menuTriggerIndex = menu.getAttribute('data-menu-trigger');
        const menuContent = document.querySelector('.secondary-mega-menu__content[data-menu-content="' + menuTriggerIndex + '"]');
        
        if (menuContent) {
          // Function to show menu
          function showMenu() {
            // Clear all timeouts first
            Object.keys(hideTimeouts).forEach(function(key) {
              clearTimeout(hideTimeouts[key]);
              delete hideTimeouts[key];
            });
            
            // Hide all other menus immediately
            hideAllMenusExcept(menuContent);
            
            // Show this menu
            menuContent.classList.add('is-visible');
            header.classList.add('secondary-mega-menu-open');
          }
          
          // Function to hide menu with delay
          function hideMenu() {
            // Clear any existing timeout for this menu
            if (hideTimeouts[menuTriggerIndex]) {
              clearTimeout(hideTimeouts[menuTriggerIndex]);
            }
            
            hideTimeouts[menuTriggerIndex] = setTimeout(function() {
              // Only hide if mouse is not over trigger or dropdown
              if (!menu.matches(':hover') && !menuContent.matches(':hover')) {
                menuContent.classList.remove('is-visible');
                
                // Only remove header class if no other menu is visible
                if (!hasVisibleMenu()) {
                  header.classList.remove('secondary-mega-menu-open');
                }
              }
              
              // Clean up timeout reference
              delete hideTimeouts[menuTriggerIndex];
            }, 100); // Small delay to allow mouse movement
          }
          
          // Mouse enter on trigger - show menu
          menu.addEventListener('mouseenter', showMenu);
          
          // Mouse leave on trigger - hide menu (with delay)
          menu.addEventListener('mouseleave', hideMenu);
          
          // Mouse enter on dropdown - keep it visible
          menuContent.addEventListener('mouseenter', showMenu);
          
          // Mouse leave on dropdown - hide it (with delay)
          menuContent.addEventListener('mouseleave', hideMenu);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
